import {
  MapboxEventArgs,
  MapboxToolEvents,
} from 'editor/components/map/MapboxEvents/mapboxEventHandlers';
import Markup from 'editor/components/Markup';
import MarkupKit from 'editor/components/MarkupKit';
import {
  BoxControlPoint,
  boxControlPointHit,
} from 'editor/utils/controlPoints';
import { getSheetLayerHits } from 'editor/utils/map';
import clickMarkupEvents from './clickMarkupEvents';
import cursorEvents from './cursorEvents';
import moveControlPointEvents from './moveControlPointEvents';
import moveMarkupEvents from './moveMarkupEvents';

const pointerEvents: MapboxToolEvents = {
  mousedown: (
    args: MapboxEventArgs<mapboxgl.MapEventType['mousedown']>
  ): void => {
    const { world, evt } = args;

    let controlPointHit = false;

    getSheetLayerHits(world, evt.lngLat.lng, evt.lngLat.lat).forEach(
      (layerHit) => {
        const { hit } = layerHit;
        if (!hit) return;

        world
          .locateAll([Markup, MarkupKit])
          .filter((ent) => ent.get(Markup).selected)
          .forEach((ent) => {
            const { MKPoint } = ent.get(MarkupKit);
            const markupComp = ent.get(Markup);
            const point = new MKPoint(hit.x, hit.y);
            controlPointHit =
              boxControlPointHit(markupComp, point) !== BoxControlPoint.None;
          });
      }
    );

    if (controlPointHit) {
      moveControlPointEvents.mousedown(args);
    } else {
      moveMarkupEvents.mousedown(args);
    }
  },

  mousemove: (
    args: MapboxEventArgs<mapboxgl.MapEventType['mousemove']>
  ): void => {
    cursorEvents.mousemove(args);
    moveMarkupEvents.mousemove(args);
    moveControlPointEvents.mousemove(args);
  },

  mouseup: (args: MapboxEventArgs<mapboxgl.MapEventType['mouseup']>): void => {
    moveMarkupEvents.mouseup(args);
    moveControlPointEvents.mouseup(args);
  },

  touchstart: (
    args: MapboxEventArgs<mapboxgl.MapEventType['touchstart']>
  ): void => {
    const { world, evt } = args;

    let controlPointHit = false;

    getSheetLayerHits(world, evt.lngLat.lng, evt.lngLat.lat).forEach(
      (layerHit) => {
        const { hit } = layerHit;
        if (!hit) return;

        world
          .locateAll([Markup, MarkupKit])
          .filter((ent) => ent.get(Markup).selected)
          .forEach((ent) => {
            const { MKPoint } = ent.get(MarkupKit);
            const markupComp = ent.get(Markup);
            const point = new MKPoint(hit.x, hit.y);
            controlPointHit =
              boxControlPointHit(markupComp, point) !== BoxControlPoint.None;
          });
      }
    );

    if (controlPointHit) {
      moveControlPointEvents.touchstart(args);
    } else {
      moveMarkupEvents.touchstart(args);
    }
  },

  touchmove: (
    args: MapboxEventArgs<mapboxgl.MapEventType['touchmove']>
  ): void => {
    moveMarkupEvents.touchmove(args);
    moveControlPointEvents.touchmove(args);
  },

  touchend: (
    args: MapboxEventArgs<mapboxgl.MapEventType['touchend']>
  ): void => {
    moveMarkupEvents.touchend(args);
    moveControlPointEvents.touchend(args);
  },

  click: (args: MapboxEventArgs<mapboxgl.MapEventType['click']>): void => {
    clickMarkupEvents.click(args);
  },
};

export default pointerEvents;
